
export const isLogicOption = (option: any): option is { label: string; type: string } => {
    return typeof option === "object" && option !== null && "label" in option;
};